import React from 'react';
import PropTypes from 'prop-types';
import { branch, compose, withPropsOnChange, renderNothing } from 'recompose';

import { Text } from 'components/core/Text';
import { H2 } from 'components/core/Typography';

export const enhance = compose(
	branch((props) => !props.totalItems && !!props.hideIfEmpty, renderNothing),
	withPropsOnChange(
		['page', 'itemsPerPage', 'totalItems'],
		({ page, itemsPerPage, totalItems }) => ({
			start: (page - 1) * itemsPerPage + 1,
			end: Math.min(page * itemsPerPage, totalItems),
		})
	)
);

export function PaginationSummary({
	start,
	end,
	totalItems,
	label,
	prefix,
	strong,
	isDot,
	isNearMePage,
}) {
	return !totalItems ? (
		<Text
			className="pagination-summary"
			strong={strong}
		>
			0 {label}
		</Text>
	) : (
		<H2 className="pagination-summary">
			{!!prefix &&
				(isNearMePage
					? `${start} - ${end} of ${totalItems} ${label.trim()} Near You`
					: `${start} - ${end} of ${totalItems} ${label.trim()} ${label.trim() === 'reviews' ? 'is' : 'in'} ${prefix}`)}
		</H2>
	);
}

PaginationSummary.propTypes = {
	label: PropTypes.string,
	totalItems: PropTypes.number,
	start: PropTypes.number,
	end: PropTypes.number,
	prefix: PropTypes.string,
	strong: PropTypes.bool,
	isDot: PropTypes.bool,
};

PaginationSummary.defaultProps = {
	start: 0,
	end: 0,
	totalItems: 0,
	label: '',
	prefix: '',
	strong: true,
};

export default enhance(PaginationSummary);
